const hasArrayEqualContents = (arr1:unknown[], arr2:unknown[]) => {
  if (arr1.length !== arr2.length) return false;
  const arr1Sorted = [...arr1].sort();
  const arr2Sorted = [...arr2].sort();
  return arr1Sorted.every((value, index) => value === arr2Sorted[index]);
};

export default hasArrayEqualContents;
